// Standard incident categories. Backend stores the `value` (lowercase keyword);
// frontend renders the `label` (human-readable). The AI suggestion service
// returns one of these values (or 'other') based on the same vocabulary.

export const INCIDENT_CATEGORIES = [
  { value: 'fire',        label: 'Fire' },
  { value: 'gas',         label: 'Gas' },
  { value: 'electrical',  label: 'Electrical' },
  { value: 'structural',  label: 'Structural' },
  { value: 'water',       label: 'Water / flooding' },
  { value: 'asbestos',    label: 'Asbestos' },
  { value: 'security',    label: 'Security' },
  { value: 'health',      label: 'Health & safety' },
  { value: 'lift',        label: 'Lift / elevator' },
  { value: 'other',       label: 'Other' },
]

const CATEGORY_LABEL_MAP = INCIDENT_CATEGORIES.reduce((acc, c) => {
  acc[c.value] = c.label
  return acc
}, {})

export const incidentCategoryLabel = (value) => {
  if (!value) return 'Incident'
  if (CATEGORY_LABEL_MAP[value]) return CATEGORY_LABEL_MAP[value]
  // Unknown value (e.g. AI returned something off-vocabulary). Capitalise it.
  return String(value).charAt(0).toUpperCase() + String(value).slice(1)
}

export const INCIDENT_TYPE_META = {
  accident:  { label: 'Accident',  colour: '#b00020', bg: '#fdecea' },
  near_miss: { label: 'Near miss', colour: '#d97706', bg: '#fef3c7' },
  incident:  { label: 'Incident',  colour: '#475569', bg: '#e2e8f0' },
}

export const INVESTIGATION_STATUS_META = {
  pending:     { label: 'Investigation pending', colour: '#33becc', bg: '#e6f7f9' },
  in_progress: { label: 'Investigating',         colour: '#4f46e5', bg: '#e0e7ff' },
  completed:   { label: 'Investigated',          colour: '#15803d', bg: '#dcfce7' },
}

export const SEVERITY_META = {
  critical: { label: 'Critical', colour: '#b00020', bg: '#fdecea' },
  high:     { label: 'High',     colour: '#c2410c', bg: '#ffedd5' },
  medium:   { label: 'Medium',   colour: '#d97706', bg: '#fef3c7' },
  low:      { label: 'Low',      colour: '#15803d', bg: '#dcfce7' },
}

export const STATUS_META = {
  open:     { label: 'Open',     colour: '#0f766e', bg: '#ccfbf1' },
  resolved: { label: 'Resolved', colour: '#15803d', bg: '#dcfce7' },
  closed:   { label: 'Closed',   colour: '#475569', bg: '#e2e8f0' },
}

export const ACTION_STATUS_META = {
  open:      { label: 'Open',      colour: '#0f766e', bg: '#ccfbf1' },
  converted: { label: 'Converted', colour: '#15803d', bg: '#dcfce7' },
  dismissed: { label: 'Dismissed', colour: '#475569', bg: '#e2e8f0' },
  resolved:  { label: 'Resolved',  colour: '#15803d', bg: '#dcfce7' },
}
